import { call, put, all, takeLatest } from 'redux-saga/effects';
import * as Actions from './actions';
import * as Constants from './Constants';
import { setTagging } from '../../../components/common/Tagging/index';
// import { showLoader, hideLoader } from '../../../components/common/Loader/action';
import { getUrlName } from '../../../components/common/Helpers';

export function* invokeTagging({ data }) {
  // yield put(showLoader());
  yield put({ type: Constants.ASYNC_FETCH });
  try {
    const apiResponse = yield call(Actions.invokeTagging, data);
    const pageName = getUrlName(window.location.href);
    if (apiResponse && apiResponse?.data && apiResponse.status === 200) {
      yield put({ type: Constants.READDL_SUCCESS, response: true });
      // yield put({ type: Constants.TAGGING_SUCCESS, response: apiResponse.data });
      // Success response from tagging api
      // yield put(setTagging(pageName, apiResponse.data));
      const response = {
        ...apiResponse?.data,
        ...data,
      };
      yield all([
        // yield put(setTagging(pageName, apiResponse.data)),
        yield put({ type: Constants.TAGGING_SUCCESS, response: apiResponse.data?.page?.channelSession }),
        yield put(setTagging(pageName, response)),
      ]);
      //  yield put({ type: Constants.TAGGING_SUCCESS, response: apiResponse.data });
      // yield put(hideLoader());
    } else if (window.location.href.indexOf('confirmation') > -1 || window.location.href.indexOf('registration') > -1) {
      yield call(Actions.invokeTagging, data);
    } else {
      yield put({ type: Constants.READDL_SUCCESS, response: false });
    }
  } catch (error) {
    // yield put({ type: Constants.ERR_OCCURED });
    // yield put(hideLoader());
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* actionWatcher() {
  yield takeLatest(Constants.INVOKE_TAGGING, invokeTagging);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
